import React, { useEffect, useRef, useState } from "react";
import { InventoryApiService } from "../../Service/InventoryApiService";
import { DataGrid } from '@mui/x-data-grid';
import { Typography, Tooltip, IconButton, ClickAwayListener } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import { GridColDef } from "@mui/x-data-grid";
import "../Dynamic/UserList.scss";
import { CommonService } from "../../Service/CommonService";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useRoute } from "../Common/route";
import { Link } from "react-router-dom";
import ExpandMore from '../../assets/images/icons/ExpandMore.svg';
import { Form} from "react-bootstrap";
import StatusDropdown from "../Common/StatusDropdown";
import Constant from "../../Constant";
import ReplayIcon from '@mui/icons-material/Replay';
import DataGridLoader from "../Common/DataGridLoader";

const BarrelSyncPanel: React.FC = () => {

    const route = useRoute();
    const history = useHistory();
    const [syncJobLogs, setSyncJobLogs] = useState<any[]>([]);
    const [barrelSyncLogs, setBarrelSyncLogs] = useState<any[]>([]);
    const [transferLogs, setTransferLogs] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [totalCount, setTotalCount] = useState(0);
    const [syncType, setSyncType] = useState(Constant.SyncType.KEGHOUND_TO_WHITEDOG);
    const [showDropdown, setShowDropdown] = useState(false);
    const buttonRef = useRef<HTMLDivElement>(null);
    const divRef = useRef<HTMLDivElement>(null);
    const [sortField, setSortField] = useState("CreatedModifiedDate"); // Default sort
    const [sortDirection, setSortDirection] = useState("asc"); // Default ascending
    const [filter, setFilter] = useState<any>({
        jobDate: null,
        startTime: null,
        endTime: null,
        status: null,
        reason: null,
        total: null,
        skipped: null,
        inserted: null,
        updated: null
    });

    const statusOptions = [
        { value: "IN_PROCESS", label: "In Process" },
        { value: "COMPLETED", label: "Completed" },
        { value: "FAILED", label: "Failed" },
    ];
  const [openTooltipId, setOpenTooltipId] = useState(null);

const handleClick = (event, id) => {
  if (event) event.stopPropagation();
  setOpenTooltipId((prev) => (prev === id ? null : id));
};

const handleClickAway = () => {
  setOpenTooltipId(null);
};

  // const isStickyNoteVisible =
  //   (params.row.status === "COMPLETED" &&
  //     params.row.reason === "No Container to sync") ||
  //   (params.row.status === "FAILED" && params.row.reason);

    const handleSortChange = (sortModel) => {
        if (sortModel.length > 0) {
            const newSortField = sortModel[0].field;
            const newSortDirection = sortModel[0].sort; // "asc" or "desc" directly from DataGrid
            
            setSortField(newSortField);
            setSortDirection(newSortDirection);

            getAllSyncJobLog(page, pageSize, filter, newSortField, newSortDirection);
            
        }
    }; 

    useEffect(() => {
        handleSyncTypeChange(localStorage.getItem("syncType"));
    }, []);

    const toggleDropdown = () => {
        setShowDropdown((prev) => !prev);
    }

    const handleBack = () => {
        history.push("/master/dashboard");
    };

    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          divRef.current &&
          !divRef.current.contains(event.target as Node) &&
          buttonRef.current &&
          !buttonRef.current.contains(event.target as Node)
        ) {
          setShowDropdown(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [showDropdown]); // Only run when dropdown is toggled

    const handleFilterChange = (
      event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
      field: keyof any
    ) => {
      const value = event.target.value;

      // Prepare a temporary filter object with the updated field value
      const tempFilter = {
        ...filter, // Spread existing filter state
        [field]: field === "status" && value === "" ? null : value, // Update field only if the condition is met
      };

      // Update the filter state
      setFilter(tempFilter);

      //call api
      getAllSyncJobLog(page, pageSize, tempFilter, sortField, sortDirection);
    };

    const handleStatusFilterChange = (
      event: any,
      value: string,
      status: string | null
    ) => {
      const isChecked = event.target.checked;

      // Convert the status string to an array
      const statusArray = status ? status.split(",") : [];

      // Update the status list based on checkbox state
      const updatedStatusArray = isChecked
        ? [...statusArray, value] // Add status if checked
        : statusArray.filter((s) => s !== value); // Remove status if unchecked

      // Convert array back to a comma-separated string
      const updatedStatus = updatedStatusArray?.length > 0 ? updatedStatusArray.join(",") : null;

      // Update the filter state with the modified status string
      setFilter({ ...filter, status: updatedStatus });

      //call api
      getAllSyncJobLog(page, pageSize, { ...filter, status: updatedStatus }, sortField, sortDirection );
    };

    const getAllSyncJobLog = async ( page: any, pageSize: any, filter: any, sortField: any, sortDirection: any) => {
      const controller = new AbortController();
      const signal = controller.signal;
      try {
        setLoading(true);
        const response: any = await InventoryApiService.getAllSyncJobLog(page, pageSize, filter, sortField, sortDirection,signal);
        setSyncJobLogs(response?.data?.content || []);
        setTotalCount(response?.data?.totalElements);
      } catch (error) {
        console.error("Failed to fetch sync job logs", error);
      } finally {
        setLoading(false);
      }
    };

    const exportKeghoundBarrelSyncLog = async (jobId: any) => {
        try {
            setLoading(true);
            const response = await InventoryApiService.exportKeghoundBarrelSyncLog(jobId);
            // Open the URL in a new tab without affecting the current page
            window.open(response.data, "_blank", "noopener,noreferrer");

            //setBarrelSyncLogs(response.data || []);
            // exportToExcel(response.data, "Barrel Sync Log", ["barrelId", "barrelNumber", "ownerId", "ownerName", "lotNo", "status", "reason"])
        } catch (error) {
            console.error("Failed to fetch barrel sync logs", error);
        } finally {
            setLoading(false);
        }
    };

    const getAllOwnershipTransferLog = async ( page: any, pageSize: any) => {
       const controller = new AbortController();
       const signal = controller.signal;
        try {
            setLoading(true);
            const response = await InventoryApiService.getAllOwnershipTransferLog(page, pageSize, signal);
            setTransferLogs(response?.data?.content || []);
            setTotalCount(response?.data?.totalElements);
        } catch (error) {
            console.error("Failed to fetch ownership transfer logs", error);
        } finally {
            setLoading(false);
        }
    };

    const manualSync = async (transferRequestId : any) => {
       try {
            setLoading(true);
            const response = await InventoryApiService.manualSync(transferRequestId);
            CommonService.Toast.fire({
                title: "Manual sync process started successfully",
                icon: "success",
              });
        } catch (error) {
            console.error("Error occurred in manual sync", error);
            CommonService.Toast.fire({
                title: "There is some technical problem in manual sync",
                icon: "error",
              });
        } finally {
            setLoading(false);
            getAllOwnershipTransferLog(page, pageSize);
        }
    }

    const getStatusOptions = () => {
        return statusOptions;
    }

    //add tooltip
    const CellWithTooltip = ({ value }: { value: string | number }) => {
        return (
            <Tooltip arrow title={value?.toString()}>
                <span>{value?.toString()}</span>
            </Tooltip>
        );
    };

    const handleRowClick = (params) => {
      if(params.row.khTransferId != null)
        history.push(`/master/transfer-lot-logs/${params.row.id}`);
    }

    const keghoundDataWithIds = syncJobLogs.map((rowData, index) => ({
        ...rowData,
    }));

    const whitedogDataWithIds = transferLogs.map((rowData, index) => ({
        ...rowData,
    }));

    const keghoundToWhitedog: GridColDef[] = [

    // We don't need to show this job Data because we are already showing start time and end time (May 7, 2025)
    //   {
    //     field: "jobDate",
    //     headerName: "Job Date",
    //     flex: 1,
    //     minWidth: 200,
    //     valueGetter: (value: any, row: any) =>
    //       `${CommonService.formatStrictDate(row.jobDate) ?? ""}`,
    //     headerClassName: "table-header border-0 my-2 h-100",
    //     renderHeader: (params) => (
    //       <div>
    //         <Typography
    //           variant="body2"
    //           sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //         >
    //           {params.colDef.headerName}
    //         </Typography>
    //         <div className="position-relative" style={{ width: "120px" }}>
    //           <input
    //             type="date"
    //             className="form-control border mt-1"
    //             style={{ boxShadow: "none" }}
    //             id="birthdate"
    //             name="modifiedDate"
    //             placeholder="MM/DD/YYYY"
    //             //value={filter.modifiedOn}
    //             defaultValue={filter.jobDate}
    //             onChange={(event) => handleFilterChange(event, "jobDate")}
    //             onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //           />
    //         </div>
    //       </div>
    //     ),
    //     renderCell: (params: any) => <CellWithTooltip value={params.value} />,
    //   },
      {
        field: "startTime",
        headerName: "Start Time",
        flex: 1,
        minWidth: 200,
        valueGetter: (value: any, row: any) =>
          `${CommonService.formatDateTime(row.startTime) ?? ""}`,
        headerClassName: "table-header border-0 my-2 h-100",
        renderHeader: (params) => (
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div className="position-relative" style={{ width: "120px" }}>
              <input
                type="date"
                className="form-control border mt-1"
                style={{ boxShadow: "none" }}
                id="birthdate"
                name="modifiedDate"
                placeholder="MM/DD/YYYY"
                value={filter.startTime}
                defaultValue={filter.startTime}
                onChange={(event) => handleFilterChange(event, "startTime")}
                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
              />
            </div>
          </div>
        ),
        renderCell: (params: any) => (
          <CellWithTooltip value={params.value || "-"} />
        ),
      },
      {
        field: "endTime",
        headerName: "End Time",
        flex: 1,
        minWidth: 200,
        valueGetter: (value: any, row: any) =>
          `${CommonService.formatDateTime(row.endTime) ?? ""}`,
        headerClassName: "table-header border-0 my-2 h-100",
        renderHeader: (params) => (
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div className="position-relative" style={{ width: "120px" }}>
              <input
                type="date"
                className="form-control border mt-1"
                style={{ boxShadow: "none" }}
                id="birthdate"
                name="modifiedDate"
                placeholder="MM/DD/YYYY"
                value={filter.endTime}
                defaultValue={filter.endTime}
                onChange={(event) => handleFilterChange(event, "endTime")}
                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
              />
            </div>
          </div>
        ),
        renderCell: (params: any) => (
          <CellWithTooltip value={params.value || "-"} />
        ),
      },
      {
        field: "total",
        headerName: "Total",
        minWidth: 150,
        flex: 1,
        headerClassName: "table-header border-0 my-2 h-100",
        renderHeader: (params) => (
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div className="position-relative" style={{ width: 100 }}>
              <input
                type="text"
                className="form-control border mt-1"
                style={{ textIndent: "24px", boxShadow: "none" }}
                placeholder="Search"
                value={filter.total}
                defaultValue={filter.total}
                onChange={(event) => handleFilterChange(event, "total")}
                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
              />
              <SearchIcon
                sx={{
                  color: "#6F6F6F",
                  position: "absolute",
                  top: "50%",
                  left: "8px",
                  transform: "translateY(-50%)",
                }}
              />
            </div>
          </div>
        ),
        renderCell: (params: any) => (
          <CellWithTooltip value={params.value || "-"} />
        ),
      },
      {
        field: "skipped",
        headerName: "Skipped",
        minWidth: 150,
        flex: 1,
        headerClassName: "table-header border-0 my-2 h-100",
        renderHeader: (params) => (
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div className="position-relative" style={{ width: 100 }}>
              <input
                type="text"
                className="form-control border mt-1"
                style={{ textIndent: "24px", boxShadow: "none" }}
                placeholder="Search"
                value={filter.skipped}
                defaultValue={filter.skipped}
                onChange={(event) => handleFilterChange(event, "skipped")}
                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
              />
              <SearchIcon
                sx={{
                  color: "#6F6F6F",
                  position: "absolute",
                  top: "50%",
                  left: "8px",
                  transform: "translateY(-50%)",
                }}
              />
            </div>
          </div>
        ),
        renderCell: (params: any) => (
          <CellWithTooltip value={params.value || "-"} />
        ),
      },
      {
        field: "inserted",
        headerName: "Inserted",
        minWidth: 150,
        flex: 1,
        headerClassName: "table-header border-0 my-2 h-100",
        renderHeader: (params) => (
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div className="position-relative" style={{ width: 100 }}>
              <input
                type="text"
                className="form-control border mt-1"
                style={{ textIndent: "24px", boxShadow: "none" }}
                placeholder="Search"
                value={filter.inserted}
                defaultValue={filter.inserted}
                onChange={(event) => handleFilterChange(event, "inserted")}
                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
              />
              <SearchIcon
                sx={{
                  color: "#6F6F6F",
                  position: "absolute",
                  top: "50%",
                  left: "8px",
                  transform: "translateY(-50%)",
                }}
              />
            </div>
          </div>
        ),
        renderCell: (params: any) => (
          <CellWithTooltip value={params.value || "-"} />
        ),
      },
      {
        field: "updated",
        headerName: "Updated",
        minWidth: 150,
        flex: 1,
        headerClassName: "table-header border-0 my-2 h-100",
        renderHeader: (params) => (
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div className="position-relative" style={{ width: 100 }}>
              <input
                type="text"
                className="form-control border mt-1"
                style={{ textIndent: "24px", boxShadow: "none" }}
                placeholder="Search"
                value={filter.updated}
                defaultValue={filter.updated}
                onChange={(event) => handleFilterChange(event, "updated")}
                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
              />
              <SearchIcon
                sx={{
                  color: "#6F6F6F",
                  position: "absolute",
                  top: "50%",
                  left: "8px",
                  transform: "translateY(-50%)",
                }}
              />
            </div>
          </div>
        ),
        renderCell: (params: any) => (
          <CellWithTooltip value={params.value || "-"} />
        ),
      },
      {
        field: "status",
        headerName: "Status",
        cellClassName: "status-badge",
        headerClassName: "table-header border-0 my-2 h-100",
        flex: 1,
        minWidth: 240,
        renderCell: (params: any) => (
          <div
            className="dropdown-nospacing"
            onClick={(e) => e.stopPropagation()}
          >
            <StatusDropdown
              currentStatus={params.row.status}
              onStatusChange={(e) => console.log(e)}
              disableCondition={true}
              allowedLabels={[]}
            />
          </div>
        ),
        renderHeader: (params) => (
          <>
            <div>
              <Typography
                variant="body2"
                sx={{ color: "#6F6F6F", fontSize: "14px" }}
              >
                {params.colDef.headerName}
              </Typography>

              <div className="position-relative" style={{ width: "185px" }}>
                <div
                  className="form-control mb-1"
                  style={{
                    cursor: "pointer",
                    borderBottomColor: "#D1D1D1",
                    marginTop: "4px",
                    background: "#fff",
                    padding: "5px",
                    overflowX: "hidden",
                    paddingRight: "16px",
                    textOverflow: "ellipsis",
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    toggleDropdown();
                  }}
                  ref={buttonRef}
                >
                  {filter.status?.length > 0
                    ? CommonService.formatStatus(filter.status).join(", ")
                    : "Select Status"}

                  <img
                    src={ExpandMore}
                    className="position-absolute top-50 end-0 translate-middle"
                  />
                </div>
                {/* Custom Dropdown */}
                {showDropdown && (
                  <div
                    className="dropdown-menu show status-multiselect-dropdown"
                    onClick={(event) => event.stopPropagation()}
                    ref={divRef}
                  >
                    {getStatusOptions().map((option) => (
                      <Form.Check
                        key={option.value}
                        id={`status-${option.value}`}
                        type="checkbox"
                        label={option.label}
                        value={option.value}
                        checked={
                          filter.status?.split(",").includes(option.value) ||
                          false
                        }
                        onChange={(event) => {
                          event.stopPropagation();
                          handleStatusFilterChange(
                            event,
                            option.value,
                            filter.status
                          );
                        }}
                        className="cursor-pointer"
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        field: "action",
        headerName: "Action",
        flex: 1,
        minWidth: 150,
        sortable: false,
        valueGetter: (value: any, row: any) => `${row.status ?? ""}`,
        headerClassName: "table-header border-0 my-2 h-100",
        renderCell: (params: any) =>
          params.row.status === "COMPLETED" ? (
            params.row.reason === "No containers to sync" ? (
              <ClickAwayListener onClickAway={handleClickAway}>
                <Tooltip
                  title={`Reason: ${params.row.reason}`}
                  open={openTooltipId === params.row.id}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray", marginTop: "5.5px" }}
                    onClick={(e) => handleClick(e, params.row.id)}
                    onMouseEnter={() => handleClick(null, params.row.id)}  // show on hover
                    onMouseLeave={() => handleClickAway()}                  // hide on leave
                    onTouchStart={(e) => handleClick(e, params.row.id)}
                  />
                </Tooltip>
              </ClickAwayListener>
            ) : (
              <Tooltip title="Export" arrow>
                <FileDownloadOutlinedIcon
                  sx={{ marginTop: "5.5px" }}
                  onClick={() => exportKeghoundBarrelSyncLog(params.row.id)}
                />
              </Tooltip>
            )
          ) : params.row.status === "FAILED" && params.row.reason && (
            <ClickAwayListener onClickAway={handleClickAway}>
              <Tooltip
                title={`Reason: ${params.row.reason}`}
                open={openTooltipId === params.row.id}
                arrow
              >
                <StickyNote2Icon
                  className="note-icon cursor-pointer"
                  style={{ color: "gray" }}
                  onClick={(e) => handleClick(e, params.row.id)}
                  onMouseEnter={() => handleClick(null, params.row.id)}  // show on hover
                  onMouseLeave={() => handleClickAway()}                  // hide on leave
                  onTouchStart={(e) => handleClick(e, params.row.id)}
                />
              </Tooltip>
            </ClickAwayListener>
          )
      },
    ];

    const whitedogToKeghound: GridColDef[] = [
        {
            field: "requestNumber",
            headerName: "Request Number",
            minWidth: 200,
            flex: 1,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => {
                const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
                const path =  params.row.requestType === 'CUSTOMER_SERVICE_REQUEST'
                                ? 'view-customer-service-request'
                                    : params.row.requestType === 'ORDER_REQUEST'
                                ? 'order-detail'
                                    : 'view-offer-request';
                return (
                    <a href="#">
                        <Link
                            to={`${linkPrefix}/${path}/${params.row.requestId}`}
                            className="link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <CellWithTooltip value={params.row.requestNumber} />
                        </Link>
                    </a>
                );
            },
        },
        {
            field: "requestType",
            headerName: "Request Type",
            minWidth: 150,
            flex: 1,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <CellWithTooltip value={params.value?.toLowerCase()?.replace(/_/g, " ")?.replace(/\b\w/g, c => c.toUpperCase()) || "-"} />
            ),
        },
        {
            field: "khTransferId",
            headerName: "Keghound Transfer Id",
            minWidth: 150,
            flex: 1,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <CellWithTooltip value={params.value || "-"} />
            ),
        },
        {
            field: "startTime",
            headerName: "Start Time",
            flex: 1,
            minWidth: 200,
            valueGetter: (value: any, row: any) => `${CommonService.formatDateTime(row.startTime) ?? ""}`,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <CellWithTooltip value={params.value || "-"} />
            ),
        },
        {
            field: "endTime",
            headerName: "End Time",
            flex: 1,
            minWidth: 200,
            valueGetter: (value: any, row: any) => `${CommonService.formatDateTime(row.endTime) ?? ""}`,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <CellWithTooltip value={params.value || "-"} />
            ),
        },
        {
            field: "transferDate",
            headerName: "Transfer Date",
            flex: 1,
            minWidth: 200,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <CellWithTooltip value={params.value} />
            ),
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            minWidth: 200,
            valueGetter: (value: any, row: any) => `${row.status ?? ""}`,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                     <div
                      className="dropdown-nospacing"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <StatusDropdown
                        currentStatus={params.row.status}
                        onStatusChange={(e) => console.log(e)}
                        disableCondition={true}
                        allowedLabels={[]}
                      />
                    </div>
                    {params.row.status === "FAILED" && params.row.reason && (
                        // <Tooltip title={`Reason: ${params.row.reason}`} arrow>
                        //     <StickyNote2Icon
                        //         className="note-icon cursor-pointer"
                        //         style={{ color: "gray" }}
                        //     />
                        // </Tooltip>
                  <ClickAwayListener onClickAway={handleClickAway}>
                    <Tooltip
                      title={`Reason: ${params.row.reason}`}
                      open={openTooltipId === params.row.id}
                      disableFocusListener
                      disableTouchListener
                      arrow
                    >
                      <StickyNote2Icon
                        className="note-icon cursor-pointer"
                        style={{ color: "gray" }}
                        onClick={(e) => handleClick(e, params.row.id)}
      onMouseEnter={() => handleClick(null, params.row.id)}  // show on hover
      onMouseLeave={() => handleClickAway()}                  // hide on leave
      onTouchStart={(e) => handleClick(e, params.row.id)}
                      />
                    </Tooltip>
                  </ClickAwayListener>
                    )}
                </div>
            )
        },
        {
            field: "action",
            headerName: "Action",
            flex: 1,
            minWidth: 150,
            sortable: false,
            valueGetter: (value: any, row: any) => `${row.status ?? ""}`,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) =>
                  params.row.status === "FAILED" && params.row.reason && (
                      <div className="dropdown-nospacing" onClick={(e) => e.stopPropagation()}>
                        <Tooltip title="Manual Sync" arrow>
                           <button style={{ background: "none", border: "none" }} 
                              onClick={() => manualSync(params.row?.id)} disabled={loading}>
                              <ReplayIcon sx={{ transform: "rotate(-45deg)", fill: "#333333" }} />
                          </button>
                        </Tooltip>
                      </div>
                )                      
        }
    ];

    const onPaginationModelChange = (newPaginationModel) => {
        setPage(newPaginationModel.page);
        setPageSize(newPaginationModel.pageSize);

        // Fetch using the latest sorting values
        if (syncType === Constant.SyncType.KEGHOUND_TO_WHITEDOG) 
            getAllSyncJobLog(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
        else if (syncType === Constant.SyncType.WHITEDOG_TO_KEGHOUND)
            getAllOwnershipTransferLog(newPaginationModel.page, newPaginationModel.pageSize);
        
    };

    const exportToExcel = (data: any[], fileName: string, columns: string[]) => {

        const filteredData = data.map((item) =>
            columns.reduce((acc: any, key) => {
                acc[key] = item[key];
                return acc;
            }, {})
        );

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${fileName}.xlsx`);
    };

    const handleSyncTypeChange = (e: any) => {

        let value = typeof e === 'string' ? e : e.target.value;
        setSyncType(value);
        localStorage.setItem("syncType", value);
        if (value === Constant.SyncType.KEGHOUND_TO_WHITEDOG)
            getAllSyncJobLog(page, pageSize, filter, sortField, sortDirection);
        else if (value === Constant.SyncType.WHITEDOG_TO_KEGHOUND)
            getAllOwnershipTransferLog(page, pageSize);

    };

    return (
        <div className="usersList pb-5">
            <div className="usersList__header--wrapper d-flex flex-wrap align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                    <IconButton
                        onClick={handleBack}
                        aria-label="ArrowBackIcon"
                        sx={{
                            backgroundColor: "#FFF",
                            "&:hover": { backgroundColor: "#FFF" },
                        }}
                    >
                        <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                    </IconButton>
                    <div className="header--title">
                        <h1 className="title mb-0">
                            Container Sync Log
                        </h1>
                    </div>
                </div>
                <div className="barrel-sync-page-dropdown">
                    <Form.Select aria-label="Select Sync Type" onChange={handleSyncTypeChange} value={syncType}>
                        <option value="KEGHOUND_TO_WHITEDOG">Keghound To Whitedog</option>
                        <option value="WHITEDOG_TO_KEGHOUND">Whitedog To Keghound</option>
                    </Form.Select>
                </div>

            </div>

            <div className="user-table-container">
                <div className="userTable">
                    <DataGrid
                        rows={syncType === Constant.SyncType.KEGHOUND_TO_WHITEDOG ? keghoundDataWithIds : whitedogDataWithIds}
                        columns={syncType === Constant.SyncType.KEGHOUND_TO_WHITEDOG ? keghoundToWhitedog : whitedogToKeghound}
                        className="data-grid support-req--listing"
                        initialState={{
                            pagination: {
                                paginationModel: { page, pageSize },
                            },
                        }}
                        pagination
                        rowCount={totalCount}
                        paginationModel={{ page, pageSize }}
                        paginationMode="server"
                        sortingMode={syncType === Constant.SyncType.KEGHOUND_TO_WHITEDOG ? "server" : "client"}
                        onPaginationModelChange={onPaginationModelChange}
                        onSortModelChange={syncType === Constant.SyncType.KEGHOUND_TO_WHITEDOG ? handleSortChange : undefined}
                        disableRowSelectionOnClick={true}
                        pageSizeOptions={[10, 20, 50, 100]}
                        loading={loading}
                        slots={{
                          loadingOverlay: DataGridLoader,
                        }}
                        disableColumnResize
                        onRowClick={handleRowClick}
                    />
                </div>
            </div>
        </div>

    );
};

export default BarrelSyncPanel;